export const DEFAULT_LAYOUT_SETTINGS = {
    labelIndent: 'space',
    amountPosition: 'adjacent',
    spacesPerLevel: 4,
    showGridlines: false,
    freezeHeaderRow: true,
    repeatHeaderOnPrint: true,
};
//# sourceMappingURL=row-node.js.map